export default "__VITE_ASSET__a3508df4__"